import { useQuery } from "@tanstack/react-query";
import { PresignedUrls } from "~/api/model";

export type UrlsWithRotate = {
  urls: PresignedUrls;
  rotate: number;
};

export const useGetUrls = (
  pageId: string,
  getUrlsFn: () => Promise<PresignedUrls>,
  canLoad: boolean
) => {
  return useQuery<UrlsWithRotate>({
    queryKey: ["pageUrlsRotate", pageId],

    queryFn: async (): Promise<UrlsWithRotate> => {
      const urls = await getUrlsFn();
      return {
        urls,
        rotate: urls.rotate ?? 0,
      };
    },

    staleTime: 12 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: canLoad,
  });
};
